import React from 'react';
import { useIntl } from 'react-intl';
import { ColumnFlexBox } from '../../../../Components/FlexBox';
import { Typography } from '@mui/material';
import CaptionValue from '../../../../Components/CaptionValue/CaptionValue';
import { formatThousands } from '../../../../Utils/constants/general';

const TooltipContent = function TooltipContent({ data }) {
  const intl = useIntl();

  return data?.target ? (
    <ColumnFlexBox gap="8px" padding="8px">
      <Typography
        variant="body1"
        sx={{
          textAlign: "center",
          fontWeight: 'bold'
        }}>
        {intl.messages.TARGET}
      </Typography>
      <Typography
        variant="body1"
        sx={{
          textAlign: "center",
          fontWeight: 'bold',
          color: data?.color
        }}>
        {data.target}
      </Typography>
    </ColumnFlexBox>
  ) : (
    <ColumnFlexBox gap="8px" padding="8px" minWidth="240px">
      <Typography
        variant="body1"
        sx={{
          textAlign: "center",
          fontWeight: 'bold'
        }}>
        {data?.key}
      </Typography>
      <Typography variant="body2" sx={{
        textAlign: "center"
      }}>
        {data?.index === 0
          ? intl.messages.OUTBOUND_CALLS_MADE
          : intl.messages.ANSWERED_CALLS}
      </Typography>
      <Typography
        variant="h6"
        sx={{
          textAlign: "center",
          color: data?.color,
          fontWeight: 'bold'
        }}>
        {formatThousands(data?.value || 0)}
      </Typography>
      {data?.details?.map(({ name, callCount, answeredCallCount }) => (
        <CaptionValue
          key={name}
          direction="row"
          width="100%"
          caption={name}
          value={
            data?.index === 0
              ? formatThousands(callCount)
              : formatThousands(answeredCallCount)
          }
          valueColor={data?.color}
          captionStyle={{ flexGrow: 1 }}
          valueStyle={{ fontWeight: 'bold' }}
          captionColor="#fff"
        />
      ))}
    </ColumnFlexBox>
  );
};

export default TooltipContent;
